import React, {useEffect, useState} from 'react';
import {CourseService} from "../../service/CourseService";
import {useNavigate} from "react-router-dom";
import HeroArea from "../../components/homes/home/hero-area";
import CategoryArea from "../../components/homes/home/category-area";
import TopCategories from "../../components/homes/home/top-categories";
import CtaArea from "../../components/homes/home/cta-area";
import CounterUpArea from "../../components/homes/home/counter-up-area";
import AboutArea from "../../components/homes/home/about-area";
import CourseArea from "../../components/homes/home/course-area";
import TestimonialArea from "../../components/homes/home/testimonial-area";
import TeamArea from "../../components/homes/home/team-area";
import AdBanner from "../../components/homes/home/ad-banner";
import BrandArea from "../../components/homes/home/brand-area";
import sal from "sal.js";
import TeamAreaSwiper from "../../components/homes/home/team-area-swiper";
// import Banner from "../../components/banner/Banner";


const Home = () => {

    useEffect( () => {
        sal( { threshold: 0.1, once: true } );
    }, [window.location.href] );

    useEffect( () => {
        sal();
    }, [] );


    return (
        <>
            <HeroArea/>
            <CategoryArea/>
            <TopCategories/>
            <AboutArea/>
            {/*<CounterUpArea/>*/}
            <CourseArea/>
            <TestimonialArea/>
            <CtaArea/>
            <TeamAreaSwiper/>
            <AdBanner/>
            <BrandArea/>

        </>
    );
}

export default Home;